//组件模块
import HelloWorld from './components/HelloWorld.vue' 
import NiurenDetail from './components/NiurenDetail.vue'
import History from './components/History.vue'
import Follow from './components/Follow.vue'
import BecomeNiuren from './components/BecomeNiuren.vue'
import SubmitSuccess from './components/SubmitSuccess.vue'
import Welcome from './components/Welcome.vue'

export default({
  routes: [
    { path: '/', component: Welcome,meta: {
                title: '跟单-首页',
            } },
	{ path: '/Home', component: HelloWorld ,meta: {
                title: '跟单-首页',
            }},
    { path: '/NiurenDetail', name:'NiurenDetail', component: NiurenDetail ,meta: {
                title: '跟单-牛人详情',
            }},
	{ path: '/History', name:'History', component: History ,meta: {
                title: '跟单-历史记录',
            }},
	{ path: '/Follow', name:'Follow', component: Follow ,meta: {
                title: '跟单-我要跟单',
            }},
	{ path: '/BecomeNiuren', component: BecomeNiuren ,meta: {
                title: '跟单-成为牛人',
            }},
	{ path: '/SubmitSuccess', name:'SubmitSuccess', component: SubmitSuccess,meta: {
                title: '跟单-提交结果',
            } }
  ],
  mode : 'history'
})
